var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCubeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 56,
    viewBox: "0 0 74 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29848 83.8022L50.9864 110.827C51.1697 111 51.3531 111 51.7198 111C51.9031 111 52.0864 111 52.2698 110.827L101.958 83.8022C102.324 83.629 102.691 83.1092 102.691 82.7628V29.0601C102.691 28.7136 102.508 28.1939 102.141 28.0207L52.4531 0.129926C52.0864 -0.0433086 51.5364 -0.0433086 51.1697 0.129926L1.48184 28.0207C1.11514 28.1939 0.748447 28.7136 0.748447 29.0601V82.7628C0.565097 83.1092 0.748425 83.629 1.29848 83.8022ZM100.124 82.0698L53.0032 107.709V56.7776L100.124 31.1389V82.0698ZM51.5364 2.55521L98.6574 29.0601L51.5364 54.3523L4.41545 29.0601L51.5364 2.55521Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubeFilled);
export default __webpack_public_path__ + "static/media/cubeFilled.7c3faaa2b1659b4c98c0ebfd3f19d0d0.svg";
export { ForwardRef as ReactComponent };